<!--
 * @Author: zhangzhitao
 * @Date: 2019-10-22 09:35:42
 * @LastEditors  : zhangzhitao
 * @LastEditTime : 2020-01-02 19:58:31
 * @Description:
 -->

<template>
  <div
    class="attachment-info"
    :class="{canClick: !qrcode && !$slots.default}"
    @click="downloadFile"
  >
    <div class="icon">
      <img :src="icon">
    </div>
    <div class="info">
      <h5
        class="name"
        :title="name"
      >{{name}}</h5>
      <div
        class="size"
        v-show="size!==0"
      >{{size | fixedTwo}}</div>
      <div
        class="desc"
        :title="desc"
      >{{desc}}</div>
    </div>
    <div
      class="qrcode"
      v-if="qrcode"
    >
      <canvas ref="canvas"></canvas>
      <span class="size">{{size | fixedTwo}}</span>
    </div>
    <div
      class="subitem-wrapper"
      v-if="this.$slots.default"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  props: {
    icon: String,
    name: String,
    desc: String,
    qrcode: {
      type: Boolean,
      default: false
    },
    path: String,
    size: {
      type: Number,
      default: 0
    }
  },
  filters: {
    fixedTwo (value) {
      let _val = parseFloat(value)
      if (_val !== 0) {
        return `${_val.toFixed(2)} M`
      } else {
        return 0
      }
    },
    maxLength (value) {
      if (value.length > 50) {
        return `${value.substr(0, 47)}...`
      }
      return value
    }
  },
  methods: {
    initQRCode () {
      if (!this.qrcode) return
      let canvas = this.$refs.canvas
      QRCode.toCanvas(canvas, this.path, {
        width: 92,
        height: 92,
        margin: 0
      })
    },
    downloadFile () {
      if (this.qrcode || this.$slots.default) return
      window.open(this.path)
    }
  },
  mounted () {
    this.initQRCode()
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.attachment-info {
  width: 384px;
  margin-right: 24px;
  padding: 32px 39px 32px 24px;
  background: #fff;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.04);
  display: inline-block;
  margin-bottom: 24px;
  box-sizing: border-box;
  font-size: 0;
  vertical-align: top;
  // &:nth-child(4n) {
  //   margin-right: 0;
  // }
  &.canClick {
    cursor: pointer;
  }
  .icon {
    width: 64px;
    height: 64px;
    display: inline-block;
    vertical-align: top;
    margin-right: 16px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    display: inline-block;
    vertical-align: top;
    width: 241px;
    .name {
      font-size: 14px;
      color: #4c4c4c;
      font-weight: normal;
      margin: 0 0 12px;
      line-height: 20px;
      height: 20px;
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      white-space: nowrap; /*规定段落中的文本不进行换行 */
    }
    .desc {
      font-size: 12px;
      color: #b5b5b5;
      line-height: 18px;
      overflow: hidden; /*超出部分隐藏*/
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      white-space: nowrap; /*规定段落中的文本不进行换行 */
    }
    .size {
      font-size: 12px;
      color: #c5c5c5;
      line-height: 18px;
    }
  }
  .qrcode {
    width: 92px;
    margin: 40px auto 0;
    text-align: center;
    .size {
      display: block;
      font-size: 12px;
      color: #b5b5b5;
      line-height: 18px;
      margin-top: 8px;
    }
  }
  .subitem-wrapper {
    margin-top: 40px;
    text-align: center;
  }
}
</style>
